var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("DropdownFilter", {
    attrs: {
      value: _vm.value,
      options: _vm.titles,
      loading: _vm.$apollo.queries.titles.loading,
      placeholder: _vm.placeholderText,
    },
    on: { search: (v) => (_vm.titleSearchString = v), input: _vm.handleInput },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }